<section class="page__header">
  <custom-app-bar
    [hasBackButton]="true"
    [title]="'create_list.title' | translate"
    [hasSafeArea]="!isDisplayedInBottomSheet"
  ></custom-app-bar>
</section>
<section class="page__content">
  <custom-form-field
    type="text"
    [formGroup]="listFormGroup"
    controlName="name"
    [label]="'create_list.name_form_field' | translate"
  ></custom-form-field>
</section>
<section class="page__footer">
  <button
    customButton
    size="large"
    expand="full"
    (click)="onClickAcceptButton()"
    [disabled]="(isRequestLoading$ | async) || !listFormGroup.valid"
    [isLoading]="(isRequestLoading$ | async)"
  >
    {{ "create_list.accept" | translate }}
  </button>
</section>
